import { ICard } from '../types';
import { CARD_ACTION, DAY_IN_MILLISECONDS } from '../constants/general';

const { PRETTY_STATUS, CARD_STATUS, SHIPPING_STATUS } = CARD_ACTION;

export const getPrettyStatus = (cardObject: ICard) => {
  if (cardObject) {
    if (cardObject.status === CARD_STATUS.CARD_REISSUE_NEEDS_FUND) return PRETTY_STATUS.NEEDS_FUND;
    if (cardObject.status === CARD_STATUS.SET_TO_EMBOSS) return PRETTY_STATUS.CARD_ON_PRINT;
    if (cardObject.status === CARD_STATUS.SHIPPED_AND_READY_ACTIVATE) return PRETTY_STATUS.ACTIVATION_REQUIRED;
    if (cardObject.status === CARD_STATUS.ACTIVE) {
      if (cardObject.digital && cardObject.requireActivation) {
        if (cardObject.createTime) {
          const today = new Date().getTime();
          const creationDate = typeof cardObject.createTime === 'string' ? new Date(cardObject.createTime).getTime() : cardObject.createTime.getTime();
          if (today - creationDate <= DAY_IN_MILLISECONDS) return PRETTY_STATUS.CARD_ON_PRINT;
        }
        if (cardObject.shippingStatus === SHIPPING_STATUS.RETURNED_TO_SENDER) return PRETTY_STATUS.RETURN_TO_SENDER;
        return PRETTY_STATUS.ACTIVATION_REQUIRED;
      }
      if (cardObject.shippingStatus === SHIPPING_STATUS.RETURNED_TO_SENDER) return PRETTY_STATUS.RETURN_TO_SENDER;
      return PRETTY_STATUS.ACTIVE;
    }
    if (cardObject.status === CARD_STATUS.CANCELED) {
      if (cardObject.shippingStatus === SHIPPING_STATUS.RETURNED_TO_SENDER) return PRETTY_STATUS.RETURN_TO_SENDER;
      return PRETTY_STATUS.UNKNOWN;
    }
  }
  return PRETTY_STATUS.UNKNOWN;
};

export const canActivatePhysicalCard = (cardObject: ICard) => getPrettyStatus(cardObject) === PRETTY_STATUS.ACTIVATION_REQUIRED;

export const canFreezeCard = (cardObject:ICard) => getPrettyStatus(cardObject) === PRETTY_STATUS.ACTIVE || cardObject.digital;

export const canSetPin = (cardObject:ICard) => getPrettyStatus(cardObject) === PRETTY_STATUS.ACTIVE;

export const canCashbackRewards = (cardObject:ICard) => getPrettyStatus(cardObject) === PRETTY_STATUS.ACTIVE || cardObject.digital;

export const getMostRelevantCard = (customerCards: ICard[]) => {
  // if (!customerCards) return null;
  const cards = [...customerCards];
  cards.forEach((card: ICard) => {
    const pStatus = getPrettyStatus(card);
    card.prettyStatus = pStatus || 0;
  });
  cards.sort((a: ICard, b: ICard) => (b.prettyStatus || 0) - (a.prettyStatus || 0));
  return cards[0];
};
